import { cva } from 'class-variance-authority';
import { Icon } from '@alto-avios/alto-ui';
import { useButton } from '@react-aria/button';
import { useRef } from 'react';

import { useRouterLink } from '../../contexts/router/useRouterLink.ts';

import styles from './MobileMenuButton.module.css';
import { MobileMenuButtonProps } from './MobileMenuButton.props.ts';

const mobileMenuButtonStyles = cva(styles.mobileMenuButton, {
  variants: {
    size: {
      default: styles.default,
      comfortable: styles.comfortable,
    },
    emphasis: {
      accent: styles.accent,
      neutral: styles.neutral,
    },
    divider: {
      withDivider: styles.divider,
    },
  },
});

export const MobileMenuButton = ({
  emphasis = 'neutral',
  size = 'default',
  children,
  iconStartName,
  hasDivider,
  hasIconStartInStack,
  hideChevron,
  disableRouting,
  ...props
}: MobileMenuButtonProps) => {
  const ref = useRef<Element | null>(null);
  const className = mobileMenuButtonStyles({
    size,
    emphasis,
    divider: hasDivider ? 'withDivider' : undefined,
  });

  const routerLink = useRouterLink({ href: props.href, disableRouting });

  const { buttonProps } = useButton({ ...routerLink, ...props }, ref);

  const Component = routerLink.as!;

  return (
    <Component ref={ref} className={className} {...props} {...buttonProps}>
      {iconStartName && <Icon iconName={iconStartName} iconPrefix="far" iconSize="1x" />}
      {hasIconStartInStack && !iconStartName ? <div className={styles.hasIconStartInStack} data-testid="spacing-div" /> : null}
      <div className={styles.label}>{children}</div>
      {!hideChevron && typeof props.href !== 'string' && <Icon iconName="chevron-right" iconPrefix="far" iconSize="1x" />}
    </Component>
  );
};
